// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__omTzh","Dialog":"style_Dialog__xaWkj"};